import {generateSeoInfo} from '../../modules/seo/seoUtils';
import {PAGINATION_PARAM_NAMES} from '../../common/pagination/paginationConstants';
import {generateAppliedFacetArray, generateAutoAppliedCount} from '../../views/filter/facet/facetUtils';

function generateDefaultInitialSearchState() {
  return {
    searchSeoInfo: null,
    searchProductArray: null,
    searchProductPaginationParams: {
      pageNumber: 1,
    },
    totalSearchProductCount: 0,
    searchSearchPass: null,
    searchShippingType: null,
    searchContext: null,
    isTolkienBrandFiltersApplied: null,
    ignoreTolkien: null,
    townToTownEAD: [],
    keywordsForCategory: [],
    productSuggestionExist: false,
    productSuggestion: null,
    searchTermTypo: null,
    isFetching: false,
    algKey: '',
    initialPageNumber: null,
    cardType: null
  };
}

function searchReducer(state = generateDefaultInitialSearchState(), action) {
  let newState;
  switch (action.type) {
    case 'GET_SEARCH_PRODUCTS': {
      newState = {
        ...state,
        isFetching: true
      }

      break;
    }
    case'GET_SEARCH_PRODUCTS_FULFILLED': {
      const {
        products,
        totalProductCount,
        seoInformation: rawSeoInformation,
        appliedFacets,
        searchPass,
        searchContext,
        isTolkienBrandFiltersApplied,
        ignoreTolkien,
        townToTownEAD,
        hasProductSuggestions,
        productSuggestion,
        cardType,
        typo,
        scoreFunctionName,
        al_g: algKey,
        keywordsForCategory,
      } = action.payload.response.data.data;
      const appliedFacetArray = generateAppliedFacetArray(appliedFacets);
      const autoAppliedFacetCount = generateAutoAppliedCount(appliedFacets);

      newState = {
        ...state,
        isFetching: false,
        searchProductArray: products,
        cardType,
        algKey,
        totalSearchProductCount: totalProductCount,
        searchSeoInfo: rawSeoInformation && generateSeoInfo(
          rawSeoInformation,
        ),
        searchShippingType: rawSeoInformation && generateSeoInfo(
          rawSeoInformation,
        ).utagData.shipping_type ? generateSeoInfo(
            rawSeoInformation,
          ).utagData.shipping_type : '',
        searchSearchPass: searchPass,
        scoreFunctionName,
        searchProductPaginationParams: {
          ...state.searchProductPaginationParams,
          ...action.triggerPayload.params,
          pageNumber:
            parseInt(action.triggerPayload.params[PAGINATION_PARAM_NAMES.PAGE], 10),
        },
        searchContext,
        isTolkienBrandFiltersApplied,
        ignoreTolkien,
        townToTownEAD,
        appliedFacetsForSearch: appliedFacetArray,
        searchAutoAppliedFacetCount: state.searchAutoAppliedFacetCount ? state.searchAutoAppliedFacetCount : autoAppliedFacetCount,
        productSuggestionExist: hasProductSuggestions,
        productSuggestion: productSuggestion,
        searchTermTypo: {
          searchTerm: typo?.searchTerm || '',
          suggestedTerm: typo?.suggestedTerm || '',
          decision: typo?.suggestionDecision || '',
        },
        initialPageNumber: action.triggerPayload.params[PAGINATION_PARAM_NAMES.PAGE],
        keywordsForCategory,
      };

      break;
    }

    case 'GET_SEARCH_FILTERS_FULFILLED': {
      const searchSeoInfo = Object.assign(
        state.searchSeoInfo,
        {breadcrumbArray: action?.payload?.response?.data?.data?.breadcrumbs}
      )

      newState = {
        ...state,
        searchSeoInfo
      }

      break;
    }

    case'GET_NEXT_SEARCH_PRODUCTS_FULFILLED': {
      const {
        products,
        totalProductCount,
        seoInformation: rawSeoInformation,
        searchContext,
        isTolkienBrandFiltersApplied,
        ignoreTolkien,
        townToTownEAD,
      } = action.payload.response.data.data;

      newState = {
        ...state,
        searchProductArray: state.searchProductArray.concat(
          products
        ),
        cardType,
        searchShippingType: generateSeoInfo(rawSeoInformation) && generateSeoInfo(rawSeoInformation)?.utagData ?
          generateSeoInfo(rawSeoInformation)?.utagData?.shipping_type : '',
        totalSearchProductCount: totalProductCount,
        searchSeoInfo: generateSeoInfo({
          ...rawSeoInformation,
          h2: state?.searchSeoInfo?.h2,
          seoParagraph: state?.searchSeoInfo?.seoParagraph,
        }),
        searchProductPaginationParams: {
          ...state.searchProductPaginationParams,
          ...action.triggerPayload.params,
          pageNumber:
            parseInt(action.triggerPayload.params[PAGINATION_PARAM_NAMES.PAGE], 10),
        },
        searchContext,
        isTolkienBrandFiltersApplied,
        ignoreTolkien,
        townToTownEAD,
      };

      break;
    }

    case 'LEAVE_SEARCH_PAGE_ROUTE': {
      newState = {
        ...state,
        searchProductArray: null,
        searchSeoInfo: null,
        searchProductPaginationParams: {
          pageNumber: 1,
        },
        productSuggestionExist: false,
        productSuggestion: null,
        searchTermTypo: null,
      };

      break;
    }

    default:
      newState = state;
  }

  return newState;
}

export default searchReducer;
export {generateDefaultInitialSearchState};
